module.exports = __webpack_public_path__ + "img/cu.245f4efc.png";